<span [ngClass]="styleMap[style]" class="badge">
    <ng-content></ng-content>
</span>
